import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { SlateJsProxy } from '~publish/legacy/composer/composer/entities/EditorStateProxy/SlateJsProxy'
import { logError } from '~publish/legacy/utils/logError'

export const ERROR_REPORTING_PLUGIN_KEY = 'error-reporting'

type Callback<T extends unknown[], R = unknown> = (
  this: unknown,
  ...args: T
) => R

const isCallback = (value: unknown): value is Callback<unknown[], unknown> =>
  typeof value === 'function'

const handleErrorCallback = <T extends unknown[], R>(
  callback: Callback<T, R>,
  editor: BufferEditor,
) =>
  function (this: unknown, ...args: T): R {
    try {
      return Reflect.apply(callback, this, args)
    } catch (error) {
      logError(error, {
        context: 'SlateError',
        metaData: {
          editorId: editor?.id ?? 'No id found',
          editorStructure: SlateJsProxy.flattenEditorStructure(editor),
        },
      })
      throw error
    }
  }

export const withErrorReporting = (editor: BufferEditor): BufferEditor => {
  Object.entries(editor).forEach(([key, value]) => {
    if (isCallback(value)) {
      editor[key] = handleErrorCallback(value, editor)
    }
  })

  return editor
}
